import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useRemoveContract } from 'modules/ats/components/VonqImportedContracts/useRemoveContract'
import type { Contract } from 'modules/ats/lib/vonq'
import { useIsContractInBasket } from 'modules/ats/lib/vonq'

interface Props {
  contract: Contract
  hasCheckout?: boolean
}

const getLogo = (contract: Contract) => {
  const defaultLogo = contract.channel?.logo_url?.[0]?.url
  const squareLogo = contract.channel?.logo_square_url?.[0]?.url
  const rectangleLogo = contract.channel?.logo_rectangle_url?.[0]?.url

  return defaultLogo || squareLogo || rectangleLogo || ''
}

export const ContractCard = ({ contract, hasCheckout }: Props) => {
  const [removeAlertOpen, setRemoveAlertOpen] = React.useState(false)
  const isIncluded = useIsContractInBasket(contract.contract_id)
  const { removeContract, isRemoving } = useRemoveContract()

  return (
    <Box
      key={contract.contract_id}
      background="grey100"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      overflowX="hidden"
      gridColSpan={{ s: 6, m: 3 }}
    >
      <Box height="s120" background="grey000White" alignItems="center">
        <img src={getLogo(contract)} alt="" style={{ maxHeight: '100%' }} />
      </Box>
      <Box gap="s24" padding="s16" flexGrow>
        <Box flexGrow>
          <Text.Header2 htmlTag="p">{contract.channel?.name}</Text.Header2>
          <Text.Normal>{contract.channel?.type.toUpperCase()}</Text.Normal>
          <Text.Normal size="200">{contract.group?.name}</Text.Normal>
        </Box>

        {hasCheckout ? (
          <Button
            type="secondary"
            onClick={() => {
              isIncluded
                ? window.hapi.basket.service?.removeProductOrContractById.run(contract.contract_id)
                : window.hapi.basket.service?.addProductOrContractById.run(
                    contract.contract_id,
                    false,
                    false
                  )
            }}
          >
            {isIncluded
              ? i18n.t('ats.vonq.contracts_list.remove_from_campaign')
              : i18n.t('ats.vonq.contracts_list.add_to_campaign')}
          </Button>
        ) : (
          <Button type="secondary" onClick={() => setRemoveAlertOpen(true)}>
            {i18n.t('ats.vonq.contracts_list.remove_contract')}
          </Button>
        )}
      </Box>

      {removeAlertOpen && (
        <Modal
          illustration="delete"
          title={i18n.t('ats.vonq.remove_contract_alert.title')}
          description={i18n.t('ats.vonq.remove_contract_alert.description')}
          onClose={() => setRemoveAlertOpen(false)}
          onSubmit={() => removeContract(contract.contract_id)}
          footer={
            <Button type="negative" disabled={isRemoving} submit>
              {i18n.t('ats.vonq.remove_contract_alert.cta')}
            </Button>
          }
        />
      )}
    </Box>
  )
}
